let config = {};

config.ipfsGatewayUrl = `https://ipfs.infura.io:5001`;


module.exports = config;
